// import './navigation';
import "SLICK/slick.js";
import "MFP/jquery.magnific-popup.js";

(function ($) {
  $(document).ready(function () {
    // console.log('starter theme...');

    $("#primary-nav-toggle").on("click", function slideMenu(e) {
      // console.log("burger click");
      let $this = $(this);
      let expanded = $this.attr("aria-expanded") == "true" || false;
      $this.attr("aria-expanded", !expanded);
      $this.siblings(".menu-primary-menu-container").toggleClass("open");
    });

    let $mainNavTopParentLinks = $("#primary-menu > .menu-item-has-children");
    let $mainNavParentLinks = $("#primary-menu .menu-item-has-children");
    $mainNavTopParentLinks.each(function setupHoverAction(index, item) {
      let $item = $(item);
      let timer = {};
      $item.on("mouseenter", function showSub(e) {
        if (window.matchMedia("(min-width: 981px)").matches) {
          let $subMenu = $(this).children(".sub-menu");
          $subMenu.css({
            opacity: 1,
            visibility: "visible"
          });
          // reveal any opened submenus to retain their state
          $subMenu.find(".sub-menu.open").addClass("show");
          // still hovering, cancel closing of this menu
          clearTimeout(timer);
        }
      });
      $item.on("mouseleave", function maybeHideSubmenu(e) {
        if (window.matchMedia("(min-width: 981px)").matches) {
          timer = setTimeout(() => {
            let $subMenu = $(this).children(".sub-menu").first();
            // hide any open nested sub menus but don't close them, this retains their open state when hovering again
            $subMenu.find(".sub-menu.open").removeClass("show");
            // set opacity 0 to allow animate fading in.
            $subMenu.css({
              opacity: 0,
              visibility: "hidden"
            });
          }, 300);
        }
      });
    });

    // $mainNavTopParentLinks.on('blur','button',function() {
    //   console.log('blur');
    //   let $button = $(this);
    //   let expanded = $button.attr('aria-expanded') == 'true' || false;
    //   if (expanded) {
    //     $button.attr('aria-expanded', false);
    //     let $subMenu = $(this).siblings('.sub-menu').first();
    //     $subMenu.stop(true, false, true).slideToggle(300);
    //   }
    // });

    $mainNavTopParentLinks.on("keyup", function (e) {
      if (window.matchMedia("(min-width: 981px)").matches) {
        let spaceBar = 32;
        let enter = 13;
        if (e.keyCode == spaceBar || e.keyCode == enter) {
          let $button = $(this).children("button").first();
          let expanded = $button.attr("aria-expanded") == "true" || false;
          $button.attr("aria-expanded", !expanded);
          let $subMenu = $(this).children(".sub-menu").first();
          $subMenu.stop(true, false, true).slideToggle(300);
        }
      }
    });

    let $nestedSubMenuButtons = $("#primary-menu .sub-menu .menu-item-has-children button");

    $nestedSubMenuButtons.on("keyup", function (e) {
      e.stopPropagation();
    });

    $nestedSubMenuButtons.on("click", function (e) {
      e.stopPropagation();
      if (window.matchMedia("(min-width: 981px)").matches) {
        $(this).parents(".menu-item-has-children").children(".sub-menu").first().toggleClass(["open", "show"]);
      }
    });
    const $siteNav = $("#site-navigation");

    $("#primary-nav-toggle").on("click", function (e) {
      let $button = $(this);
      // $("body").toggleClass("menu-open");
      let expanded = $button.attr("aria-expanded") == "true";
      $button.next(".menu-main-menu-container").prop("hidden", !expanded);
    });

    let closeMenu = function ($toggleButton, focusButton = false) {
      $toggleButton.attr("aria-expanded", false);
      $toggleButton.next(".menu-main-menu-container").prop("hidden", true);
      // $("body").removeClass("menu-open");
      if (focusButton) {
        $toggleButton.focus();
      }
      return this;
    };

    $siteNav.on("keyup", function (e) {
      const ESC = 27;
      let $toggleButton = $(this).find("#primary-nav-toggle");
      let expanded = $toggleButton.attr("aria-expanded") == "true";
      if (!expanded) {
        return;
      }

      if (e.keyCode == ESC) {
        closeMenu($toggleButton, true);
      }
    });

    $siteNav.find("#primary-menu").on("focusout", function (e) {
      let $navButton = $siteNav.find("#primary-nav-toggle");
      if ($navButton.attr("aria-expanded") == "false") {
        return;
      }
      if ($(e.relatedTarget).parent().hasClass("menu-item") == false) {
        closeMenu($navButton, false);
      }
    });

    // Magnific popup for floor plans
    $(".gallery-lightbox-image").magnificPopup({
      type: "image",
      gallery: {
        enabled: true
      },
      image: {
        markup: '<div class="mfp-figure">' + '<div class="mfp-close"></div>' + '<div class="mfp-img"></div>' + '<div class="mfp-bottom-bar">' + '<div class="mfp-title"></div>' + '<div class="mfp-counter"></div>' + "</div>" + "</div>" // Popup HTML markup. `.mfp-img` di
      },
      verticalFit: true // Fits image in area vertically
    });

    // Magnific popup for floor plans
    $(".mnrk-lightbox-image").magnificPopup({
      type: "image",
      image: {
        markup: '<div class="mfp-figure">' + '<div class="mfp-close"></div>' + '<div class="mfp-img"></div>' + '<div class="mfp-bottom-bar">' + '<div class="mfp-title"></div>' + '<div class="mfp-counter"></div>' + "</div>" + "</div>" // Popup HTML markup. `.mfp-img` di
      },
      verticalFit: true // Fits image in area vertically
    });

    $(".featured-fp-card").slick({
      slidesToShow: 3,
      slidesToScroll: 1,
      infinite: true,
      rows: 0,
      lazyLoad: "ondemand",
      arrows: true,
      dots: false,
      cssEase: window.noMotion ? "unset" : "ease",
      regionLabel: "featured floor plan carousel",
      responsive: [
        {
          breakpoint: 980,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            infinite: true,
            rows: 0,
            lazyLoad: "ondemand",
            arrows: false,
            dots: true
          }
        }
      ]
    });
  });
})(jQuery);
